import React, { FC } from 'react';
import { ui } from 'util/ui';

/**
 * Bucket heading bar (Videos & Audio, Assets, Notes, Gallery) with an optional "+ Add …" action.
 * Pink again, like the records bar (Aaron, 5 Nov 2026), in the customer's bucket colour
 * (Admin › Settings › Colours).
 */
const SectionHeader: FC<{ title: string; count?: number; actionLabel?: string; onAction?(): void }> = ({
  title,
  count,
  actionLabel,
  onAction,
  children,
}) => (
  <div
    style={{
      display: 'flex',
      alignItems: 'center',
      gap: 10,
      minHeight: 52,
      padding: '0 12px 0 16px',
      background: ui.bucket,
      color: '#FFFFFF',
      fontFamily: ui.font,
    }}
  >
    <h2 style={{ margin: 0, fontSize: 16, fontWeight: 700, color: '#FFFFFF' }}>{title}</h2>
    {typeof count === 'number' && (
      <span style={{ fontSize: 12, fontWeight: 600, color: '#FFFFFF', background: 'rgba(255,255,255,0.2)', borderRadius: 999, padding: '1px 8px' }}>
        {count}
      </span>
    )}
    <span style={{ flex: 1 }} />
    {children}
    {actionLabel && onAction && (
      <button
        type="button"
        className="archy-btn archy-onbucket"
        onClick={onAction}
        style={{
          height: 34,
          padding: '0 12px',
          borderRadius: 8,
          border: '1px solid rgba(255,255,255,0.55)',
          background: 'rgba(255,255,255,0.12)',
          color: '#FFFFFF',
          font: 'inherit',
          fontSize: 13,
          fontWeight: 600,
          cursor: 'pointer',
          whiteSpace: 'nowrap',
        }}
      >
        + {actionLabel}
      </button>
    )}
  </div>
);

export default SectionHeader;
